import './styles.scss'

interface NoDataInfoProps {
  title: string | JSX.Element
  iconSrc: string
  showIcon?: boolean
  minWidth?: string
}

function NoDataInfo({
  title,
  iconSrc,
  minWidth = '100%',
  showIcon = false,
}: NoDataInfoProps) {
  return (
    <div className="noDataInfo-container" style={{ minWidth: `${minWidth}` }}>
      {showIcon && <img src={iconSrc} alt={`Ícone`} />}
      <h4>{title}</h4>
    </div>
  )
}

export default NoDataInfo
